import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import { db, auth, storage } from "./firebase"

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    meetups: [],
    slides: [],
    orders: [],
    user: auth.currentUser,
    loading: false,
    error: null,
  },
  mutations: {
    createMeetup(state, payload){
      state.meetups.push(payload)
    },
    deleteMeetup(state, payload){
      state.meetups = state.meetups.filter(x => x.id != payload);
    },
    deleteSlide(state, payload){
      state.slides = state.slides.filter(x => x.id != payload);
    },
    deleteOrder(state, payload){
      state.orders = state.orders.filter(x => x.id != payload);
    },
    updateOrder(state, payload){
      state.orders.forEach((item) => {
        if( item.id == payload) {
          item.status = false;
        }
      })
    },
    setLoadedMeetups(state, payload){
      state.meetups = payload;
    },
    setLoadedOrders(state, payload){
      state.orders = payload;
    },
    setLoadedSlides(state, payload){
      state.slides = payload;
    },
    setUser(state, payload){
      state.user = payload;
    },
    signOutUser(state){
      state.user = null;
    },
    setLoading(state, payload){
      state.loading = payload;
    },
    setError(state, payload){
      state.error = payload;
    },
    clearError(state){
      state.error = null;
    },
  },
  actions: {
    loadMeetups({commit}){
      commit('setLoading', true);
      db.collection("meetups")
        .onSnapshot(function(querySnapshot) {
          const meetups = [];
          querySnapshot.forEach(function(doc) {
            const meetup = doc.data();
            meetup.id = doc.id;
            meetups.push(meetup);
          });
          commit('setLoadedMeetups', meetups);
          commit('setLoading', false);
        }, function(error) {
          console.log(error);
        });
      /*db.collection("meetups").get()
        .then(function(querySnapshot) {
          const meetups = [];
          querySnapshot.forEach(function(doc) {

            const meetup = doc.data();
            meetup.id = doc.id;
            meetups.push(meetup);

          });
          commit('setLoadedMeetups', meetups);
          commit('setLoading', false);
        })
        .catch(
          (error) => {
            console.log(error)
          }
        );*/
    },
    loadSlides({commit}){
      commit('setLoading', true);
      db.collection("slides").onSnapshot(function(querySnapshot) {
          const slides = [];
          querySnapshot.forEach(function(doc) {
            const slide = doc.data();
            slide.id = doc.id;
            slides.push(slide);
          });
          commit('setLoadedSlides', slides);
          commit('setLoading', false);
        }, function(error) {
          console.log(error);
        });
      /*db.collection("slides").get()
        .then(function(querySnapshot) {
          const slides = [];
          querySnapshot.forEach(function(doc) {

            const slide = doc.data();
            slide.id = doc.id;
            slides.push(slide);

          });
          commit('setLoadedSlides', slides);
          commit('setLoading', false);
        })
        .catch(
          (error) => {
            console.log(error)
          }
        );*/
    },
    loadOrders({commit}){
      commit('setLoading', true);
      db.collection("orders").onSnapshot(function(querySnapshot) {
          const orders = [];
          querySnapshot.forEach(function(doc) {
            const order = doc.data();
            order.id = doc.id;
            orders.push(order);
          });
          commit('setLoadedOrders', orders);
          commit('setLoading', false);
        }, function(error) {
          console.log(error);
        });
      /*
      db.collection("orders").get()
        .then(function(querySnapshot) {
          const orders = [];
          querySnapshot.forEach(function(doc) {

            const order = doc.data();
            order.id = doc.id;
            orders.push(order);

          });
          commit('setLoadedOrders', orders);
          commit('setLoading', false);
        })
        .catch(
          (error) => {
            console.log(error)
          }
        );*/
    },
    createMeetup({commit}, payload){
      commit('setLoading', true);
      const meetup = {
        room: payload.room,
        timestamp: payload.timestamp,
        duration: payload.duration,
        description: payload.description
      }

      let imageUrl = null;
      let id = null;

      db.collection("meetups").add(meetup)
        .then(function(docRef) {
          console.log("Document written with ID: ", docRef.id);
          id = docRef.id;
          return id;
        })
        .then(function(id){
          const filename = payload.image.name;
          const ext = filename.slice(filename.lastIndexOf('.'));
          return storage.ref('meetups/' + id + ext).put(payload.image);
        })
        .then(function(uploadTask) {
          return uploadTask.ref.getDownloadURL();
        })
        .then(function(downloadURL) {
          db.collection("meetups").doc(id).update({
            image: downloadURL
          })
          /*commit('createMeetup', {
            ...meetup,
            imageUrl: downloadURL,
            id: id
          })*/
          commit('setLoading', false);
        })
        .catch(function(error) {
          commit('setLoading', true);
          console.error("Error adding document: ", error);
        });
    },
    createSlide({commit}, payload){
      commit('setLoading', true);
      const slide = {
        room: payload.room
      }

      let id = null;

      db.collection("slides").add(slide)
        .then(function(docRef) {
          console.log("Document written with ID: ", docRef.id);
          id = docRef.id;
          return id;
        })
        .then(function(id){
          const filename = payload.image.name;
          const ext = filename.slice(filename.lastIndexOf('.'));
          return storage.ref('sliders/' + id + ext).put(payload.image);
        })
        .then(function(uploadTask) {
          return uploadTask.ref.getDownloadURL();
        })
        .then(function(downloadURL) {
          db.collection("slides").doc(id).update({
            image: downloadURL
          })
          commit('setLoading', false);
        })
        .catch(function(error) {
          commit('setLoading', true);
          console.error("Error adding document: ", error);
        });
    },
    createOrder({commit}, payload){
      commit('setLoading', true);
      const order = {
        room: payload.room,
        timestamp: payload.timestamp,
        water: payload.water,
        coffee: payload.coffee,
        tea: payload.tea,
        status: true,
      }

      db.collection("orders").add(order)
        .then(function(docRef) {
          commit('setLoading', false);
          console.log("Document written with ID: ", docRef.id);
        })
        .catch(function(error) {
          console.error("Error adding document: ", error);
        });
    },
    deleteMeetup({commit}, payload){
      db.collection("meetups").doc(payload).delete().then(function() {
          console.log("Document successfully deleted!");
      }).catch(function(error) {
          console.error("Error removing document: ", error);
      });
      commit('deleteMeetup', payload)
    },
    deleteSlide({commit}, payload){
      db.collection("slides").doc(payload).delete().then(function() {
          console.log("Document successfully deleted!");
      }).catch(function(error) {
          console.error("Error removing document: ", error);
      });
      commit('deleteSlide', payload)
    },
    deleteOrder({commit}, payload){
      db.collection("orders").doc(payload).delete().then(function() {
          console.log("Document successfully deleted!");
      }).catch(function(error) {
          console.error("Error removing document: ", error);
      });
      commit('deleteOrder', payload)
    },
    updateOrder({commit}, payload){
      db.collection("orders").doc(payload).update({
        status: false,
      }).then(function() {
          console.log("Document successfully updated!");
      }).catch(function(error) {
          console.error("Error removing document: ", error);
      });
      commit('updateOrder', payload)
    },
    signInUser({commit}, payload){
      commit('setLoading', true);
      commit('clearError');
      auth.signInWithEmailAndPassword(payload.email, payload.password)
        .then(data => {
          commit('setLoading', false);
          const newUser = {
            id: data.user.uid
          }
          commit('setUser', newUser);
        })
        .catch(err => {
          commit('setLoading', false);
          commit('setError', err)
          console.log(err.message);
        });
    },
    signOutUser({commit}, payload){
      auth.signOut().then(function() {
        commit('signOutUser');
      }).catch(function(error) {
        console.log(error);
      });
    },
    setUser({commit}, payload){
      commit('setUser', payload);
    },
    userIsAuthenticated({commit}) {
      auth.onAuthStateChanged((user) =>{
        if(user){
          commit('setUser', user);
        }else{
          commit('setUser', null);
        }
      });
    },
    clearError(commit){
      commit('clearError');
    },
  },
  getters: {
    loadedMeetups(state){
      return state.meetups.sort( (a,b) => b.timestamp - a.timestamp );
    },
    loadedSlides(state){
      return state.slides;
    },
    loadedOrders(state){
      return state.orders.sort( (a,b) => b.timestamp - a.timestamp );
    },
    user(state) {
      return state.user
    },
    loading(state) {
      return state.loading
    },
    error(state) {
      return state.error
    }
  }
})